import Seperator from '@components/std-components/Seperator'
import Typography from '@components/std-components/Typography'
import { useBuyingSessionGroup } from '@modules/wholesale/buyingGroupSummary/graphql/hooks'
import { useClientSummary } from '@modules/wholesale/clientSettings/graphql/hooks'
import { stores } from '@stores'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  wrapperContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 10,
    height: '46px'
  },
  elementWrapper: {
    display: 'flex',
    alignContent: 'center',
    overflow: 'hidden',
    oTextOverflow: 'ellipsis',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  ellipsisName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    textTransform: 'capitalize'
  }
}))

export const TopbarBSGandClientName: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      nav: {
        queryParams: { clientId, buyingSessionGroupId }
      },
      productConfiguration: { enhancedViewEnabled }
    } = stores
    const classes = useStyles()
    const { summary } = useClientSummary(clientId)
    const { data } = useBuyingSessionGroup(buyingSessionGroupId)

    const buyingSessionGroupName = (data?.buyingSessionGroup?.Name ?? '').toLowerCase()
    const clientName = (summary?.Name ?? '').toLowerCase()

    return (
      <div className={classes.wrapperContainer}>
        <>
          <div className={classes.elementWrapper}>
            {enhancedViewEnabled ? (
              <CentricTypography variant={'captionGrey'} className={classes.ellipsisName}>
                {clientName}
              </CentricTypography>
            ) : (
              <Typography variant='body2' classes={classes.ellipsisName}>
                {clientName}
              </Typography>
            )}
          </div>
          {clientName && buyingSessionGroupName && (
            <Seperator
              orientation='vertical'
              seperatorStyle='solid'
              seperatorColor='rgba(192,192,192,1)'
              size='20px'
              seperatorThickness='1px'
              margin='4px 16px'
            />
          )}
          <div className={classes.elementWrapper}>
            {enhancedViewEnabled ? (
              <CentricTypography variant={'captionGrey'} className={classes.ellipsisName}>
                {buyingSessionGroupName}
              </CentricTypography>
            ) : (
              <Typography variant='body2' classes={classes.ellipsisName}>
                {buyingSessionGroupName}
              </Typography>
            )}
          </div>
        </>
      </div>
    )
  })
}
